module.exports = __webpack_public_path__ + "static/media/profile-1-color-gray.58d0c42a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/profile-1-color-gray.svg
// module id = 755
// module chunks = 0